/* eslint-disable no-console */
import { datadogRum } from '@datadog/browser-rum';

export interface User {
  id?: string | undefined;
  email?: string | undefined;
  name?: string | undefined;
  [key: string]: unknown;
}
export const identifyUser = (userInfo: User) => {
  console.debug('Identifying monitoring user:', userInfo);
  datadogRum.setUser(userInfo);
};
